import { createContext } from 'react';
import { IVideos } from 'types';

export type TVideosSortBy =
	| ''
	| 'NameA-Z'
	| 'NameZ-A'
	| 'CategoriesA-Z'
	| 'CategoriesZ-A'
	| 'StudiosA-Z'
	| 'StudiosZ-A';
export type TVideosCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export interface IFilterValues {
	searchString: string;
	selectedStudio: Nullable<string>;
	selectedCategory: Nullable<string>;
	isUnassignedVideos: boolean;
	sortBy: TVideosSortBy;
	countOfItems: TVideosCountOfItems;
	currentPage: number;
}

export interface IVideosState {
	videos: IVideos;
	searchString: string;
	selectedStudio: Nullable<string>;
	selectedCategory: Nullable<string>;
	isUnassignedVideos: boolean;
	sortBy: TVideosSortBy;
	countOfItems: TVideosCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	IDForFullInfo: Nullable<string>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const videosInitialState: IVideosState = {
	videos: { videosCount: 0, videos: [] },
	searchString: '',
	selectedStudio: null,
	selectedCategory: null,
	isUnassignedVideos: false,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	IDForFullInfo: null,
	typeOfModalWindow: null,
};

export interface IVideosContext extends IVideosState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	setStudio(value: Nullable<string>): void;
	setCategory(value: Nullable<string>): void;
	resetSelectedControls(): void;
	toggleUnassignedVideos(): void;
	setSortBy(sortBy: TVideosSortBy): void;
	setCountOfItems(count: TVideosCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	setIDForFullInfo(value: Nullable<string>): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const VideosContext = createContext<IVideosContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	setStudio: () => undefined,
	setCategory: () => undefined,
	resetSelectedControls: () => undefined,
	toggleUnassignedVideos: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	setIDForFullInfo: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...videosInitialState,
});
